export const allMatches = JSON.parse(`[
    {
        "id": "GNEPF83636MF217",
        "homeTeam": {
            "id": "GNBGY5M9KMN8E53",
            "name": "Catar",
            "nameAbbrev": "QAT",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/9640.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/102370.png"
        },
        "awayTeam": {
            "id": "GN5NM2T728912WK",
            "name": "Ecuador",
            "nameAbbrev": "ECU",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4333.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3065.png"
        },
        "date": "2022-11-20T16:00:00.000Z",
        "status": "COMPLETED",
        "score": {
            "homeScore": "2",
            "awayScore": "1"
        },
        "groupId": "GNBAN17DY17C6HC",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Al Bayt Stadium"
    },
    {
        "id": "GNFAWABKD9990H7",
        "homeTeam": {
            "id": "GNEWS27CQRA7F8Q",
            "name": "Inglaterra",
            "nameAbbrev": "ENG",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2208.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/436.png"
        },
        "awayTeam": {
            "id": "GN5GBJ9XAE377F6",
            "name": "Irán",
            "nameAbbrev": "IRN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4348.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3033.png"
        },
        "date": "2022-11-21T13:00:00.000Z",
        "status": "IN_PROGRESS",
        "score": {
            "homeScore": "2",
            "awayScore": "0"
        },
        "groupId": "GNFP1FYJ0XFHG2K",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Khalifa International Stadium"
    },
    {
        "id": "GN364W6TVRDKRZJ",
        "homeTeam": {
            "id": "GN6Z2A16KJ6HV46",
            "name": "Senegal",
            "nameAbbrev": "SEN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4375.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3026.png"
        },
        "awayTeam": {
            "id": "GN1NKHKNE81WZNW",
            "name": "Países Bajos",
            "nameAbbrev": "NED",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2201.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/411.png"
        },
        "date": "2022-11-21T16:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNBAN17DY17C6HC",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Al Thumama Stadium"
    },
    {
        "id": "GNF3XBSRVW555CD",
        "homeTeam": {
            "id": "GND4E8T69HJCYCD",
            "name": "Estados Unidos",
            "nameAbbrev": "USA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2209.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3019.png"
        },
        "awayTeam": {
            "id": "GN31DA8MADTY6MC",
            "name": "Gales",
            "nameAbbrev": "WAL",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4386.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3017.png"
        },
        "date": "2022-11-21T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNFP1FYJ0XFHG2K",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Ahmed Bin Ali Stadium"
    },
    {
        "id": "GN6XKRPV0H9Z653",
        "homeTeam": {
            "id": "GN0Z3X6855XN43P",
            "name": "Argentina",
            "nameAbbrev": "ARG",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2768.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3029.png"
        },
        "awayTeam": {
            "id": "GN10Q0066RYCD63",
            "name": "Arabia Saudita",
            "nameAbbrev": "KSA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4374.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3072.png"
        },
        "date": "2022-11-22T10:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN6XTMAXA112QVK",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Lusail Iconic Stadium"
    },
    {
        "id": "GN1E0DTBDYR7HS6",
        "homeTeam": {
            "id": "GN35YRBCHES0H99",
            "name": "Dinamarca",
            "nameAbbrev": "DEN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2220.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/406.png"
        },
        "awayTeam": {
            "id": "GN0D2ZYT69QGC49",
            "name": "Túnez",
            "nameAbbrev": "TUN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2246.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3023.png"
        },
        "date": "2022-11-22T13:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN5H41S89V75M3R",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Education City Stadium"
    },
    {
        "id": "GNDRCKRB69AMZXH",
        "homeTeam": {
            "id": "GN7VASH15HKYQA7",
            "name": "México",
            "nameAbbrev": "MEX",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2228.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3010.png"
        },
        "awayTeam": {
            "id": "GN4Y21300EHG549",
            "name": "Polonia",
            "nameAbbrev": "POL",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2214.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3006.png"
        },
        "date": "2022-11-22T16:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN6XTMAXA112QVK",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Stadium 974"
    },
    {
        "id": "GN2J6T2MP4VVQ1T",
        "homeTeam": {
            "id": "GNDKWAMRBAP7DVY",
            "name": "Francia",
            "nameAbbrev": "FRA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2202.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/461.png"
        },
        "awayTeam": {
            "id": "GN4K3H1KMG1HR2E",
            "name": "Australia",
            "nameAbbrev": "AUS",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2229.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3059.png"
        },
        "date": "2022-11-22T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN5H41S89V75M3R",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Al Janoub Stadium"
    },
    {
        "id": "GN0SZVK2EN4G9HP",
        "homeTeam": {
            "id": "GNA0R58H42SG1NV",
            "name": "Marruecos",
            "nameAbbrev": "MAR",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2779.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3014.png"
        },
        "awayTeam": {
            "id": "GNAMDSYB2VWJCZY",
            "name": "Croacia",
            "nameAbbrev": "CRO",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4354.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/523.png"
        },
        "date": "2022-11-23T10:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNAQVRWVJVGM77G",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Al Bayt Stadium"
    },
    {
        "id": "GN9VSM2W6KDWNE4",
        "homeTeam": {
            "id": "GN6T73QJMJT6PGT",
            "name": "Alemania",
            "nameAbbrev": "GER",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2206.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/1500.png"
        },
        "awayTeam": {
            "id": "GN6AGN17D1B453T",
            "name": "Japón",
            "nameAbbrev": "JPN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2241.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3062.png"
        },
        "date": "2022-11-23T13:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNFMX613A54R1CW",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Khalifa International Stadium"
    },
    {
        "id": "GNEADPTR83C8585",
        "homeTeam": {
            "id": "GN8N1G480P5H6HV",
            "name": "España",
            "nameAbbrev": "ESP",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2203.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/413.png"
        },
        "awayTeam": {
            "id": "GNAMV9APZY4CSZ1",
            "name": "Costa Rica",
            "nameAbbrev": "CRC",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2771.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3090.png"
        },
        "date": "2022-11-23T16:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNFMX613A54R1CW",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Al Thumama Stadium"
    },
    {
        "id": "GN1ZTBS9ZSN9RK8",
        "homeTeam": {
            "id": "GNE0VFY10J2Q7JP",
            "name": "Bélgica",
            "nameAbbrev": "BEL",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2205.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3004.png"
        },
        "awayTeam": {
            "id": "GN9PN5ZEH07GF9F",
            "name": "Canadá",
            "nameAbbrev": "CAN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2231.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3049.png"
        },
        "date": "2022-11-23T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNAQVRWVJVGM77G",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Ahmed Bin Ali Stadium"
    },
    {
        "id": "GNCVQZ9F7D5GEHF",
        "homeTeam": {
            "id": "GNCKSCV9KY3GCDW",
            "name": "Suiza",
            "nameAbbrev": "SUI",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2213.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/408.png"
        },
        "awayTeam": {
            "id": "GNF40MXHR3YXM2S",
            "name": "Camerún",
            "nameAbbrev": "CMR",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4351.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3075.png"
        },
        "date": "2022-11-24T10:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN0VS7X9CKVQ2BK",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Al Janoub Stadium"
    },
    {
        "id": "GN2ZD8WQTTA6CXF",
        "homeTeam": {
            "id": "GN8YCH3CR2Y7CC0",
            "name": "Uruguay",
            "nameAbbrev": "URU",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2787.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3024.png"
        },
        "awayTeam": {
            "id": "GN0MFWSX7TR5TC7",
            "name": "Corea del Sur",
            "nameAbbrev": "KOR",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4391.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3068.png"
        },
        "date": "2022-11-24T13:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNDE9A5NB8NEE9C",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Education City Stadium"
    },
    {
        "id": "GN44RRTB80DFHBR",
        "homeTeam": {
            "id": "GN794EMZMP05YB5",
            "name": "Portugal",
            "nameAbbrev": "POR",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2223.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/450.png"
        },
        "awayTeam": {
            "id": "GN0MF7YTFAY301H",
            "name": "Ghana",
            "nameAbbrev": "GHA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4339.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3025.png"
        },
        "date": "2022-11-24T16:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNDE9A5NB8NEE9C",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Stadium 974"
    },
    {
        "id": "GN1W41QGSZX79PB",
        "homeTeam": {
            "id": "GNDPVBPY1CBN882",
            "name": "Brasil",
            "nameAbbrev": "BRA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2235.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/1035.png"
        },
        "awayTeam": {
            "id": "GN891PZVRCA79YW",
            "name": "Serbia",
            "nameAbbrev": "SRB",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/6944.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3000.png"
        },
        "date": "2022-11-24T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN0VS7X9CKVQ2BK",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN2TACB00XHVX4W",
        "stadium": "Lusail Iconic Stadium"
    },
    {
        "id": "GN5HZ912B1097WF",
        "homeTeam": {
            "id": "GN31DA8MADTY6MC",
            "name": "Gales",
            "nameAbbrev": "WAL",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4386.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3017.png"
        },
        "awayTeam": {
            "id": "GN5GBJ9XAE377F6",
            "name": "Irán",
            "nameAbbrev": "IRN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4348.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3033.png"
        },
        "date": "2022-11-25T10:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNFP1FYJ0XFHG2K",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Ahmed Bin Ali Stadium"
    },
    {
        "id": "GNA3X2M8TGBC0XK",
        "homeTeam": {
            "id": "GNBGY5M9KMN8E53",
            "name": "Catar",
            "nameAbbrev": "QAT",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/9640.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/102370.png"
        },
        "awayTeam": {
            "id": "GN6Z2A16KJ6HV46",
            "name": "Senegal",
            "nameAbbrev": "SEN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4375.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3026.png"
        },
        "date": "2022-11-25T13:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNBAN17DY17C6HC",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Al Thumama Stadium"
    },
    {
        "id": "GNB0AG581QHVM3A",
        "homeTeam": {
            "id": "GN1NKHKNE81WZNW",
            "name": "Países Bajos",
            "nameAbbrev": "NED",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2201.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/411.png"
        },
        "awayTeam": {
            "id": "GN5NM2T728912WK",
            "name": "Ecuador",
            "nameAbbrev": "ECU",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4333.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3065.png"
        },
        "date": "2022-11-25T16:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNBAN17DY17C6HC",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Khalifa International Stadium"
    },
    {
        "id": "GNFE4H5TDZV336D",
        "homeTeam": {
            "id": "GNEWS27CQRA7F8Q",
            "name": "Inglaterra",
            "nameAbbrev": "ENG",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2208.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/436.png"
        },
        "awayTeam": {
            "id": "GND4E8T69HJCYCD",
            "name": "Estados Unidos",
            "nameAbbrev": "USA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2209.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3019.png"
        },
        "date": "2022-11-25T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNFP1FYJ0XFHG2K",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Al Bayt Stadium"
    },
    {
        "id": "GN8W75183JFTMV0",
        "homeTeam": {
            "id": "GN0D2ZYT69QGC49",
            "name": "Túnez",
            "nameAbbrev": "TUN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2246.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3023.png"
        },
        "awayTeam": {
            "id": "GN4K3H1KMG1HR2E",
            "name": "Australia",
            "nameAbbrev": "AUS",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2229.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3059.png"
        },
        "date": "2022-11-26T10:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN5H41S89V75M3R",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Al Janoub Stadium"
    },
    {
        "id": "GN5EWWQXMEJCKB7",
        "homeTeam": {
            "id": "GN4Y21300EHG549",
            "name": "Polonia",
            "nameAbbrev": "POL",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2214.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3006.png"
        },
        "awayTeam": {
            "id": "GN10Q0066RYCD63",
            "name": "Arabia Saudita",
            "nameAbbrev": "KSA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4374.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3072.png"
        },
        "date": "2022-11-26T13:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN6XTMAXA112QVK",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Education City Stadium"
    },
    {
        "id": "GNF0K9Z86NCM273",
        "homeTeam": {
            "id": "GNDKWAMRBAP7DVY",
            "name": "Francia",
            "nameAbbrev": "FRA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2202.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/461.png"
        },
        "awayTeam": {
            "id": "GN35YRBCHES0H99",
            "name": "Dinamarca",
            "nameAbbrev": "DEN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2220.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/406.png"
        },
        "date": "2022-11-26T16:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN5H41S89V75M3R",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Stadium 974"
    },
    {
        "id": "GNCWE8W2DCYWDBE",
        "homeTeam": {
            "id": "GN0Z3X6855XN43P",
            "name": "Argentina",
            "nameAbbrev": "ARG",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2768.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3029.png"
        },
        "awayTeam": {
            "id": "GN7VASH15HKYQA7",
            "name": "México",
            "nameAbbrev": "MEX",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2228.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3010.png"
        },
        "date": "2022-11-26T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN6XTMAXA112QVK",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Lusail Iconic Stadium"
    },
    {
        "id": "GN7W3V7YBEFWKD1",
        "homeTeam": {
            "id": "GN6AGN17D1B453T",
            "name": "Japón",
            "nameAbbrev": "JPN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2241.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3062.png"
        },
        "awayTeam": {
            "id": "GNAMV9APZY4CSZ1",
            "name": "Costa Rica",
            "nameAbbrev": "CRC",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2771.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3090.png"
        },
        "date": "2022-11-27T10:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNFMX613A54R1CW",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Ahmed Bin Ali Stadium"
    },
    {
        "id": "GN9R8EP2V060482",
        "homeTeam": {
            "id": "GNE0VFY10J2Q7JP",
            "name": "Bélgica",
            "nameAbbrev": "BEL",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2205.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3004.png"
        },
        "awayTeam": {
            "id": "GNA0R58H42SG1NV",
            "name": "Marruecos",
            "nameAbbrev": "MAR",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2779.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3014.png"
        },
        "date": "2022-11-27T13:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNAQVRWVJVGM77G",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Al Thumama Stadium"
    },
    {
        "id": "GNAPNWNCVEBM4F1",
        "homeTeam": {
            "id": "GNAMDSYB2VWJCZY",
            "name": "Croacia",
            "nameAbbrev": "CRO",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4354.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/523.png"
        },
        "awayTeam": {
            "id": "GN9PN5ZEH07GF9F",
            "name": "Canadá",
            "nameAbbrev": "CAN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2231.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3049.png"
        },
        "date": "2022-11-27T16:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNAQVRWVJVGM77G",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Khalifa International Stadium"
    },
    {
        "id": "GNAP56H0SG6EBH4",
        "homeTeam": {
            "id": "GN8N1G480P5H6HV",
            "name": "España",
            "nameAbbrev": "ESP",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2203.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/413.png"
        },
        "awayTeam": {
            "id": "GN6T73QJMJT6PGT",
            "name": "Alemania",
            "nameAbbrev": "GER",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2206.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/1500.png"
        },
        "date": "2022-11-27T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNFMX613A54R1CW",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Al Bayt Stadium"
    },
    {
        "id": "GNCXTZQ7RKANW9G",
        "homeTeam": {
            "id": "GNF40MXHR3YXM2S",
            "name": "Camerún",
            "nameAbbrev": "CMR",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4351.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3075.png"
        },
        "awayTeam": {
            "id": "GN891PZVRCA79YW",
            "name": "Serbia",
            "nameAbbrev": "SRB",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/6944.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3000.png"
        },
        "date": "2022-11-28T10:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN0VS7X9CKVQ2BK",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Al Janoub Stadium"
    },
    {
        "id": "GN9J5X2YYZQG98B",
        "homeTeam": {
            "id": "GN0MFWSX7TR5TC7",
            "name": "Corea del Sur",
            "nameAbbrev": "KOR",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4391.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3068.png"
        },
        "awayTeam": {
            "id": "GN0MF7YTFAY301H",
            "name": "Ghana",
            "nameAbbrev": "GHA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4339.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3025.png"
        },
        "date": "2022-11-28T13:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNDE9A5NB8NEE9C",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Education City Stadium"
    },
    {
        "id": "GN321HS6ETD03GJ",
        "homeTeam": {
            "id": "GNDPVBPY1CBN882",
            "name": "Brasil",
            "nameAbbrev": "BRA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2235.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/1035.png"
        },
        "awayTeam": {
            "id": "GNCKSCV9KY3GCDW",
            "name": "Suiza",
            "nameAbbrev": "SUI",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2213.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/408.png"
        },
        "date": "2022-11-28T16:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN0VS7X9CKVQ2BK",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Stadium 974"
    },
    {
        "id": "GNEED51MB1R9DSA",
        "homeTeam": {
            "id": "GN794EMZMP05YB5",
            "name": "Portugal",
            "nameAbbrev": "POR",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2223.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/450.png"
        },
        "awayTeam": {
            "id": "GN8YCH3CR2Y7CC0",
            "name": "Uruguay",
            "nameAbbrev": "URU",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2787.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3024.png"
        },
        "date": "2022-11-28T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNDE9A5NB8NEE9C",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN492TFBG7DATDF",
        "stadium": "Lusail Iconic Stadium"
    },
    {
        "id": "GN25F3EDVGKKKZ9",
        "homeTeam": {
            "id": "GN1NKHKNE81WZNW",
            "name": "Países Bajos",
            "nameAbbrev": "NED",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2201.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/411.png"
        },
        "awayTeam": {
            "id": "GNBGY5M9KMN8E53",
            "name": "Catar",
            "nameAbbrev": "QAT",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/9640.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/102370.png"
        },
        "date": "2022-11-29T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNBAN17DY17C6HC",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Al Bayt Stadium"
    },
    {
        "id": "GN9JWPG9C5BEQZV",
        "homeTeam": {
            "id": "GN5NM2T728912WK",
            "name": "Ecuador",
            "nameAbbrev": "ECU",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4333.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3065.png"
        },
        "awayTeam": {
            "id": "GN6Z2A16KJ6HV46",
            "name": "Senegal",
            "nameAbbrev": "SEN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4375.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3026.png"
        },
        "date": "2022-11-29T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNBAN17DY17C6HC",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Khalifa International Stadium"
    },
    {
        "id": "GN548RNEX81F5AP",
        "homeTeam": {
            "id": "GN31DA8MADTY6MC",
            "name": "Gales",
            "nameAbbrev": "WAL",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4386.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3017.png"
        },
        "awayTeam": {
            "id": "GNEWS27CQRA7F8Q",
            "name": "Inglaterra",
            "nameAbbrev": "ENG",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2208.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/436.png"
        },
        "date": "2022-11-29T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNFP1FYJ0XFHG2K",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Ahmed Bin Ali Stadium"
    },
    {
        "id": "GN6DYTE5ZNVTVKH",
        "homeTeam": {
            "id": "GN5GBJ9XAE377F6",
            "name": "Irán",
            "nameAbbrev": "IRN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4348.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3033.png"
        },
        "awayTeam": {
            "id": "GND4E8T69HJCYCD",
            "name": "Estados Unidos",
            "nameAbbrev": "USA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2209.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3019.png"
        },
        "date": "2022-11-29T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNFP1FYJ0XFHG2K",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Al Thumama Stadium"
    },
    {
        "id": "GNCQJ517TMRMG9Y",
        "homeTeam": {
            "id": "GN4K3H1KMG1HR2E",
            "name": "Australia",
            "nameAbbrev": "AUS",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2229.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3059.png"
        },
        "awayTeam": {
            "id": "GN35YRBCHES0H99",
            "name": "Dinamarca",
            "nameAbbrev": "DEN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2220.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/406.png"
        },
        "date": "2022-11-30T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN5H41S89V75M3R",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Al Janoub Stadium"
    },
    {
        "id": "GNB4QVPY30M0ARK",
        "homeTeam": {
            "id": "GN0D2ZYT69QGC49",
            "name": "Túnez",
            "nameAbbrev": "TUN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2246.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3023.png"
        },
        "awayTeam": {
            "id": "GNDKWAMRBAP7DVY",
            "name": "Francia",
            "nameAbbrev": "FRA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2202.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/461.png"
        },
        "date": "2022-11-30T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN5H41S89V75M3R",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Education City Stadium"
    },
    {
        "id": "GN8TRV7Q0G17KF2",
        "homeTeam": {
            "id": "GN4Y21300EHG549",
            "name": "Polonia",
            "nameAbbrev": "POL",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2214.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3006.png"
        },
        "awayTeam": {
            "id": "GN0Z3X6855XN43P",
            "name": "Argentina",
            "nameAbbrev": "ARG",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2768.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3029.png"
        },
        "date": "2022-11-30T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN6XTMAXA112QVK",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Stadium 974"
    },
    {
        "id": "GN21SE8TRH740M9",
        "homeTeam": {
            "id": "GN10Q0066RYCD63",
            "name": "Arabia Saudita",
            "nameAbbrev": "KSA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4374.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3072.png"
        },
        "awayTeam": {
            "id": "GN7VASH15HKYQA7",
            "name": "México",
            "nameAbbrev": "MEX",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2228.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3010.png"
        },
        "date": "2022-11-30T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN6XTMAXA112QVK",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Lusail Iconic Stadium"
    },
    {
        "id": "GN2P1W5KKNM4WXR",
        "homeTeam": {
            "id": "GNAMDSYB2VWJCZY",
            "name": "Croacia",
            "nameAbbrev": "CRO",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4354.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/523.png"
        },
        "awayTeam": {
            "id": "GNE0VFY10J2Q7JP",
            "name": "Bélgica",
            "nameAbbrev": "BEL",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2205.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3004.png"
        },
        "date": "2022-12-01T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNAQVRWVJVGM77G",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Ahmed Bin Ali Stadium"
    },
    {
        "id": "GN1JWHD0FG7XG3B",
        "homeTeam": {
            "id": "GN9PN5ZEH07GF9F",
            "name": "Canadá",
            "nameAbbrev": "CAN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2231.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3049.png"
        },
        "awayTeam": {
            "id": "GNA0R58H42SG1NV",
            "name": "Marruecos",
            "nameAbbrev": "MAR",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2779.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3014.png"
        },
        "date": "2022-12-01T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNAQVRWVJVGM77G",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Al Thumama Stadium"
    },
    {
        "id": "GNER2AT91P6Q8N8",
        "homeTeam": {
            "id": "GN6AGN17D1B453T",
            "name": "Japón",
            "nameAbbrev": "JPN",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2241.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3062.png"
        },
        "awayTeam": {
            "id": "GN8N1G480P5H6HV",
            "name": "España",
            "nameAbbrev": "ESP",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2203.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/413.png"
        },
        "date": "2022-12-01T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNFMX613A54R1CW",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Khalifa International Stadium"
    },
    {
        "id": "GN95GDE0JDKHV80",
        "homeTeam": {
            "id": "GNAMV9APZY4CSZ1",
            "name": "Costa Rica",
            "nameAbbrev": "CRC",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2771.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3090.png"
        },
        "awayTeam": {
            "id": "GN6T73QJMJT6PGT",
            "name": "Alemania",
            "nameAbbrev": "GER",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2206.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/1500.png"
        },
        "date": "2022-12-01T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNFMX613A54R1CW",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Al Bayt Stadium"
    },
    {
        "id": "GN3Z2WQ2TCNM9AQ",
        "homeTeam": {
            "id": "GN0MF7YTFAY301H",
            "name": "Ghana",
            "nameAbbrev": "GHA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4339.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3025.png"
        },
        "awayTeam": {
            "id": "GN8YCH3CR2Y7CC0",
            "name": "Uruguay",
            "nameAbbrev": "URU",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2787.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3024.png"
        },
        "date": "2022-12-02T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNDE9A5NB8NEE9C",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Al Janoub Stadium"
    },
    {
        "id": "GN4YGH8AR10SFSB",
        "homeTeam": {
            "id": "GN0MFWSX7TR5TC7",
            "name": "Corea del Sur",
            "nameAbbrev": "KOR",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4391.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3068.png"
        },
        "awayTeam": {
            "id": "GN794EMZMP05YB5",
            "name": "Portugal",
            "nameAbbrev": "POR",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2223.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/450.png"
        },
        "date": "2022-12-02T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GNDE9A5NB8NEE9C",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Education City Stadium"
    },
    {
        "id": "GN9AD25JW9W6EAQ",
        "homeTeam": {
            "id": "GN891PZVRCA79YW",
            "name": "Serbia",
            "nameAbbrev": "SRB",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/6944.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3000.png"
        },
        "awayTeam": {
            "id": "GNCKSCV9KY3GCDW",
            "name": "Suiza",
            "nameAbbrev": "SUI",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2213.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/408.png"
        },
        "date": "2022-12-02T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN0VS7X9CKVQ2BK",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Stadium 974"
    },
    {
        "id": "GN50D69TG5DEK13",
        "homeTeam": {
            "id": "GNF40MXHR3YXM2S",
            "name": "Camerún",
            "nameAbbrev": "CMR",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4351.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3075.png"
        },
        "awayTeam": {
            "id": "GNDPVBPY1CBN882",
            "name": "Brasil",
            "nameAbbrev": "BRA",
            "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2235.png",
            "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/1035.png"
        },
        "date": "2022-12-02T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "groupId": "GN0VS7X9CKVQ2BK",
        "roundId": "GN8N2CJNFGC0M4G",
        "matchRoundId": "GN03HWNER5MEW45",
        "stadium": "Lusail Iconic Stadium"
    },
    {
        "id": "GN43VYD19YCR39C",
        "homeTeam": {
            "id": "GN9PTBBRXQMZ2JM",
            "name": "Ganador del Grupo A",
            "nameAbbrev": "1A",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GN0R99ZED8W0AJ8",
            "name": "Segundo del Grupo B",
            "nameAbbrev": "2B",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-03T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNFPAYWC9M394J5",
        "matchRoundId": "GN01S52Z1EXD5GY",
        "stadium": "Khalifa International Stadium"
    },
    {
        "id": "GNBXPFDNCQZNFK0",
        "homeTeam": {
            "id": "GN3E3ZD4E19HRWE",
            "name": "Ganador del Grupo C",
            "nameAbbrev": "1C",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GNDS97M4GVE7AZE",
            "name": "Segundo del Grupo D",
            "nameAbbrev": "2D",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-03T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNFPAYWC9M394J5",
        "matchRoundId": "GN01S52Z1EXD5GY",
        "stadium": "Ahmed Bin Ali Stadium"
    },
    {
        "id": "GN2AMZFZZ20HN5T",
        "homeTeam": {
            "id": "GN2V0C61JJ00AEM",
            "name": "Ganador del Grupo D",
            "nameAbbrev": "1D",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GN0JBFNRM684E39",
            "name": "Segundo del Grupo C",
            "nameAbbrev": "2C",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-04T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNFPAYWC9M394J5",
        "matchRoundId": "GN01S52Z1EXD5GY",
        "stadium": "Al Thumama Stadium"
    },
    {
        "id": "GN0ABM07RYFC8A3",
        "homeTeam": {
            "id": "GN7P89PHTTD73RQ",
            "name": "Ganador del Grupo B",
            "nameAbbrev": "1B",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GN4AMSSEP4E2Y50",
            "name": "Segundo del Grupo A",
            "nameAbbrev": "2A",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-04T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNFPAYWC9M394J5",
        "matchRoundId": "GN01S52Z1EXD5GY",
        "stadium": "Al Bayt Stadium"
    },
    {
        "id": "GN3FKY1WEMHG9WA",
        "homeTeam": {
            "id": "GN102JM2S5VNSQN",
            "name": "Ganador del Grupo E",
            "nameAbbrev": "1E",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GNEKGF9B9YAS75G",
            "name": "Segundo del Grupo F",
            "nameAbbrev": "2F",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-05T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNFPAYWC9M394J5",
        "matchRoundId": "GN01S52Z1EXD5GY",
        "stadium": "Al Janoub Stadium"
    },
    {
        "id": "GNBH5S0Q80B3XK8",
        "homeTeam": {
            "id": "GN8N18F85R5A9G5",
            "name": "Ganador del Grupo G",
            "nameAbbrev": "1G",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GN58N1TFAQRA7EY",
            "name": "Segundo del Grupo H",
            "nameAbbrev": "2H",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-05T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNFPAYWC9M394J5",
        "matchRoundId": "GN01S52Z1EXD5GY",
        "stadium": "Stadium 974"
    },
    {
        "id": "GND5YGNPZEXNYSE",
        "homeTeam": {
            "id": "GNEPCXRQ3HG22Q7",
            "name": "Ganador del Grupo F",
            "nameAbbrev": "1F",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GNEZSEQHZWVMFGH",
            "name": "Segundo del Grupo E",
            "nameAbbrev": "2E",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-06T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNFPAYWC9M394J5",
        "matchRoundId": "GN01S52Z1EXD5GY",
        "stadium": "Education City Stadium"
    },
    {
        "id": "GNA9DWAAWWBV699",
        "homeTeam": {
            "id": "GNBVVKC8B6RGPT8",
            "name": "Ganador del Grupo H",
            "nameAbbrev": "1H",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GN42Q6KDGHR2G55",
            "name": "Segundo del Grupo G",
            "nameAbbrev": "2G",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-06T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNFPAYWC9M394J5",
        "matchRoundId": "GN01S52Z1EXD5GY",
        "stadium": "Lusail Iconic Stadium"
    },
    {
        "id": "GNES3EQP154BW8E",
        "homeTeam": {
            "id": "GN36YB5YZZK7JA9",
            "name": "Ganador OF3",
            "nameAbbrev": "W L16 3",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GNAYEMXKEB254J2",
            "name": "Ganador OF4",
            "nameAbbrev": "W L16 4",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-09T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNDS14ZN19MA8AE",
        "matchRoundId": "GNFH226FFNRYRYC",
        "stadium": "Education City Stadium"
    },
    {
        "id": "GNATEJTA7P6C1KA",
        "homeTeam": {
            "id": "GN6HY7RY2E1TGA1",
            "name": "Ganador OF1",
            "nameAbbrev": "W L16 1",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GN9V2F5E5R0NNQB",
            "name": "Ganador OF2",
            "nameAbbrev": "W L16 2",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-09T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNDS14ZN19MA8AE",
        "matchRoundId": "GNFH226FFNRYRYC",
        "stadium": "Lusail Iconic Stadium"
    },
    {
        "id": "GNCVTZDPYMR0N4Y",
        "homeTeam": {
            "id": "GN2SJQ8Y30H5Y91",
            "name": "Ganador OF7",
            "nameAbbrev": "W L16 7",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GN08VRT93370KVG",
            "name": "Ganador OF8",
            "nameAbbrev": "W L16 8",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-10T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNDS14ZN19MA8AE",
        "matchRoundId": "GNFH226FFNRYRYC",
        "stadium": "Al Thumama Stadium"
    },
    {
        "id": "GN3KYCGVNXHVKGM",
        "homeTeam": {
            "id": "GNEP6B39C9BHN2J",
            "name": "Ganador OF5",
            "nameAbbrev": "W L16 5",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GN4JYRZPDXVQHCN",
            "name": "Ganador OF6",
            "nameAbbrev": "W L16 6",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-10T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNDS14ZN19MA8AE",
        "matchRoundId": "GNFH226FFNRYRYC",
        "stadium": "Al Bayt Stadium"
    },
    {
        "id": "GNEG7SJ9HA8DVWH",
        "homeTeam": {
            "id": "GN21MQ0QQ8PFJVF",
            "name": "Ganador CF1",
            "nameAbbrev": "W QF 1",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GNCG1TPAF9S7EVX",
            "name": "Ganador CF2",
            "nameAbbrev": "W QF 2",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-13T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNBHVT79GEK8PDY",
        "matchRoundId": "GNE7V0DCREYDG41",
        "stadium": "Lusail Iconic Stadium"
    },
    {
        "id": "GN9VS4D6ZFRFWCX",
        "homeTeam": {
            "id": "GN2SJAM74FS161S",
            "name": "Ganador CF3",
            "nameAbbrev": "W QF 3",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GN3D2K96SYTKWND",
            "name": "Ganador CF4",
            "nameAbbrev": "W QF 4",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-14T19:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNBHVT79GEK8PDY",
        "matchRoundId": "GNE7V0DCREYDG41",
        "stadium": "Al Bayt Stadium"
    },
    {
        "id": "GN3CQYV8SC71YB1",
        "homeTeam": {
            "id": "GN3M5THM9DE70NX",
            "name": "Perdedor SF1",
            "nameAbbrev": "L SF 1",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GN9SNZQ86PM9S66",
            "name": "Perdedor SF2",
            "nameAbbrev": "L SF 2",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-17T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GN0RDNSRNFX8CN5",
        "matchRoundId": "GN3M1N0DVD6YZCM",
        "stadium": "Khalifa International Stadium"
    },
    {
        "id": "GNFVEEFNVF69QGF",
        "homeTeam": {
            "id": "GN612RYBXESB6SP",
            "name": "Ganador SF1",
            "nameAbbrev": "W SF 1",
            "flag": "",
            "logo": ""
        },
        "awayTeam": {
            "id": "GN8J2B5RNRATK3R",
            "name": "Ganador SF2",
            "nameAbbrev": "W SF 2",
            "flag": "",
            "logo": ""
        },
        "date": "2022-12-18T15:00:00.000Z",
        "status": "SCHEDULED",
        "score": {},
        "roundId": "GNFEPTP0PBTFA68",
        "matchRoundId": "GNBG2X47EWJ2V64",
        "stadium": "Lusail Iconic Stadium"
    }
]`);


// WEBPACK FOOTER //
// ./src/mundial/requests/mockData/allMatches.ts